import { Box, HStack, StackProps, Text, VStack, Wrap } from "@chakra-ui/react";
import ChartDoughnut from "../dependent/ChartDoughnut";

interface Props extends StackProps {
  data: number[];
  dataCount: number[];
}

export default function ProgressCourseDashboard({
  data,
  dataCount,
  ...props
}: Props) {
  const labels = ["Selesai", "Belum Selesai"];
  const datasets = [
    {
      label: "Persentase Pengguna (%)",
      data: data,
      backgroundColor: ["#FBD38D", "#805AD5"],
      borderWidth: 0,
    },
  ];

  return (
    <VStack
      p={4}
      pb={6}
      borderRadius={8}
      bg={"white"}
      align={"stretch"}
      gap={0}
      {...props}
    >
      <Text fontWeight={500} mb={4}>
        Progres Course
      </Text>

      <Wrap m={"auto"} spacing={4}>
        <VStack flex={"1 1 0"} my={4} position={"relative"}>
          <VStack w={"100%"} maxW={"240px"} className="doughnutChartContainer">
            <ChartDoughnut labels={labels} datasets={datasets} />
          </VStack>

          <Text
            position={"absolute"}
            left={"50%"}
            top={"50%"}
            transform={"translate(-50%, -50%)"}
            fontSize={48}
            opacity={0.6}
          >
            %
          </Text>
        </VStack>

        <VStack
          flex={"1 1 0"}
          align={"stretch"}
          justify={"center"}
          maxW={"240px"}
          mx={"auto"}
        >
          <HStack gap={6}>
            <Box
              borderRadius={"full"}
              w={"10px"}
              h={"10px"}
              bg={"orange.200"}
            />

            <Text>Selesai</Text>

            <Text ml={"auto"}>
              {data[0]}% ({dataCount[0]})
            </Text>
          </HStack>

          <HStack gap={6}>
            <Box
              borderRadius={"full"}
              w={"10px"}
              h={"10px"}
              bg={"purple.400"}
            />

            <Text>Belum Selesai</Text>

            <Text ml={"auto"}>
              {data[1]}% ({dataCount[1]})
            </Text>
          </HStack>
        </VStack>
      </Wrap>
    </VStack>
  );
}
